import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { ProductCard } from '../components/ProductCard';
import { FinalOffer } from '../components/FinalOffer';
import { Footer } from '../components/Footer';
const products = [{
  title: 'Diosdado Cabello: Poder, Influencia y Trayectoria Política',
  image: 'https://cdn.magicpatterns.com/uploads/tciB1qNwyYjcCZG6xE4KZU/DIOSDADO_CABELLO_PORTADA_AUDIBLE.png',
  benefits: ['Análisis completo de su ascenso político', 'Audiolibro para aprender en movimiento', 'Presentación visual con cronología detallada'],
  ctaText: 'Descarga el pack completo de Diosdado Cabello hoy'
}, {
  title: 'Delcy Rodríguez: Diplomacia y Poder en la Política Venezolana',
  image: 'https://cdn.magicpatterns.com/uploads/acq7P3gzhsgQsbR8DzkJsd/DELCY_RODRIGUEZ_PORTADA_AUDIBLE.png',
  benefits: ['Recorrido por su carrera diplomática y política', 'Audiolibro para escuchar en cualquier lugar', 'Presentación visual para repasar los hitos clave'],
  ctaText: 'Profundiza en la trayectoria de Delcy Rodríguez: Consigue el pack ahora'
}, {
  title: 'Leopoldo López: Liderazgo Opositor y Lucha por la Democracia',
  image: 'https://cdn.magicpatterns.com/uploads/fDfTjBnSdR63oJnvpcBvRM/LEOPOLDO_LOPEZ.png',
  benefits: ['Historia completa de su activismo político', 'Audiolibro para aprender de forma práctica', 'Presentación visual con momentos decisivos'],
  ctaText: 'Accede al pack completo de Leopoldo López hoy'
}];
export function LandingPage() {
  return <main className="min-h-screen w-full bg-[#0a0a0a]" data-id="element-111">
      <HeroSection data-id="element-112" />

      {/* Divider */}
      <div className="w-full h-px bg-gradient-to-r from-transparent via-[#D4AF37]/30 to-transparent" data-id="element-113" />

      {/* Product Sections */}
      {products.map((product, index) => <div key={product.title} data-id="element-114">
          <ProductCard title={product.title} image={product.image} benefits={product.benefits} ctaText={product.ctaText} reversed={index % 2 === 1} index={index} data-id="element-115" />
          {index < products.length - 1 && <div className="w-full h-px bg-gradient-to-r from-transparent via-gray-800 to-transparent" data-id="element-116" />}
        </div>)}

      {/* Final Offer */}
      <FinalOffer data-id="element-117" />

      {/* Footer */}
      <Footer data-id="element-118" />
    </main>;
}